import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import { useNavigate, useParams } from 'react-router';
import Content from '../../../layout/content/Content';
import PageHeading from '../components/page_heading/PageHeading';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Icon } from '../../../components/Component';
import { Button, Card, Spinner } from 'reactstrap';
import CardTabs from '../components/cards/CardTabs';
import { employee_dashboard_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_loading_order_details, loading_retrieve_loading_order_details, reset_retrieve_loading_order_details, success_retrieve_loading_order_details } from '../../../reducers/dashboard_reducers/loading_orders/retrieve_loading_order_details_Slice';
import { RETRIEVE_LOADING_ORDER_DETAILS_ACCESS_DENIED_MSG, RETRIEVE_LOADING_ORDER_DETAILS_ERR_MSG, RETRIEVE_LOADING_ORDER_DETAILS_SUCCESS_MSG } from '../../../constants/success_error_messages_consts';
import { useDispatch } from 'react-redux';
import { RETRIEVE_LOADING_ORDER_DETAILS_API } from '../../../api/api_data';
import * as app_consts from "../../../constants/react_app_consts";
import { messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import ProfileDetailText from '../components/text/ProfileDetailText';
import moment from 'moment';
import ReadOnlyTable from '../components/table/ReadOnlyTable';
import { BiErrorCircle } from 'react-icons/bi';
import LoadingOrderPDF from '../components/pdf/LoadingOrderPDF';
import { PDFViewer } from '@react-pdf/renderer';
import { calculateTotalQuantity, findModuleAction, formatScientificNotation } from '../../../utils/functionalUtils';
import { Link } from 'react-router-dom';
import ModalAdd from '../components/modal/modal_add/ModalAdd';
import EditLoadingOrderDetailsModal from '../components/modal/EditLoadingOrderDetailsModal';
import EditLoadingOrderProductsModal from '../components/modal/EditLoadingOrderProductsModal';

const initial_actions_data = {
  view_loading_orders: false,
  create_loading_order: false,
};
const not_loaded_products_type = app_consts.NOT_LOADED_PRODUCTS_LOADING_ORDER_DETAILS;

const LoadingOrderDetails = () => {

  const { loading_order_ref_no } = useParams();
  const [loading, setLoading] = useState(true);
  const [activeCardTab, setActiveCardTab] = useState("Main Details");
  const [dataFetched, setDataFetched] = useState(false);
  const [page_data, setPageData] = useState([]);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [account_actions, setAccountActions] = useState([]);
  const [componentData, setComponentData] = useState(initial_actions_data);
  const navigate = useNavigate();
  const [loading_order_history, setLoadingOrderHistory] = useState([]);
  const [sm, updateSm] = useState(false);
  const [add_loading_order_products_modal, setAddGLoadingOrdersModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [edit_loading_order_details_modal, setEditLoadingOrderDetailsModal] = useState(false);
  const [edit_loading_order_products_modal, setEditLoadingOrderProductsModal] = useState(false);

  const toggleEditLoadingOrderDetailsModal = () => setEditLoadingOrderDetailsModal(!edit_loading_order_details_modal);
  const toggleEditLoadingOrderProductssModal = () => setEditLoadingOrderProductsModal(!edit_loading_order_products_modal);


  // Card Tabs
  const tabs = [
    {
      tabName: "Main Details"
    },
    {
      tabName: "Product Information"
    },
    {
      tabName: "Loading Order History"
    },
    {
      tabName: "Loading Order PDF"
    },
  ];

  //  RETRIEVE_LOADING_ORDERS_API
  useEffect(() => {
    retrive_loading_order_details();
    if (localStorage.getItem("log_cred"))
    {
      setAccountActions(JSON.parse(localStorage.getItem('log_cred'))?.user_actions);
    }
  }, []);

  const retrive_loading_order_details = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_loading_order_details,
        success_retrieve_loading_order_details,
        fail_retrieve_loading_order_details,
        RETRIEVE_LOADING_ORDER_DETAILS_ERR_MSG,
        RETRIEVE_LOADING_ORDER_DETAILS_SUCCESS_MSG,
        app_consts.GET,
        `${RETRIEVE_LOADING_ORDER_DETAILS_API}/${loading_order_ref_no}`,
        null,
        RETRIEVE_LOADING_ORDER_DETAILS_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Changes In Account Actions
  useEffect(() => {
    if (account_actions)
    {
      let actions_data = initial_actions_data;
      account_actions?.map((module) => {
        if (module.module_name === app_consts.WAREHOUSE_MANAGEMENT) 
        {
          // Actions Data
          if (findModuleAction(app_consts.CREATE_LOADING_ORDER, module))
          {
            actions_data.create_loading_order = true;
          }
        }
      });
      setComponentData(actions_data);
    }
  }, [account_actions]);

  // Listen to Changes
  const loading_order_details_listener = useSelector((state) => state.retrieve_loading_order_details.retrieve_loading_order_details);
  // 
  useEffect(() => {
    if (loading_order_details_listener.status !== app_consts.IDLE)
    {
      if (loading_order_details_listener.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (loading_order_details_listener.status === app_consts.FAIL)
        {
          setError(loading_order_details_listener.message);
          messageToast(loading_order_details_listener.message, app_consts.FAIL);
        } else if (loading_order_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(loading_order_details_listener.data);
          setLoadingOrderHistory(loading_order_details_listener.data?.inventory_history);
          setDataFetched(true);
          setProducts(loading_order_details_listener.data?.products);
        }
        dispatch(reset_retrieve_loading_order_details());
      }
    }
  }, [loading_order_details_listener]);

  const open_add_dn_products_modal = () => {
    setAddGLoadingOrdersModal(true);
  };

  const close_add_dn_products_modal = () => {
    setAddGLoadingOrdersModal(false);
  };

  const successAddFunction = () => {
    close_add_dn_products_modal();
    retrive_loading_order_details();
  };

  return (
    <>
      <Head title="Loading Order Details" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle page>{`Loading Order Details | ${loading_order_ref_no}`}</BlockTitle>
              <Link to={`/dashboard/loading_orders`}>
                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`/dashboard/loading_orders`}>
                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    {
                      (componentData?.create_loading_order || componentData?.view_loading_orders) && (
                        <>
                          {
                            page_data?.dns_length === 0 && page_data?.loading_order_status?.toLowerCase() === app_consts.PENDING_DN_PROCESSING?.toLowerCase() && (
                              <>
                                <li>
                                  <Button color="light" outline className="btn-white" onClick={toggleEditLoadingOrderDetailsModal} >
                                    <Icon name="edit"></Icon>
                                    <span>Edit Loading Order Details</span>
                                  </Button>
                                </li>
                                <li>
                                  <Button color="light" outline className="btn-white" onClick={toggleEditLoadingOrderProductssModal}>
                                    <Icon name="edit"></Icon>
                                    <span>Edit Loading Order Products</span>
                                  </Button>
                                </li>
                              </>
                            )}
                        </>
                      )}
                    {
                      findModuleAction(app_consts.CONTINUE_PROCESSING_LOADING_ORDER_ACTIONS, componentData) !== null && (
                        <>
                          {
                            page_data?.loading_order_status?.toLowerCase() === app_consts.UNDERGOING_PROCESSING?.toLowerCase() && (
                              <>
                                <li>
                                  <Button color="light" outline className="btn-white" onClick={open_add_dn_products_modal} >
                                    <Icon name="plus"></Icon>
                                    <span>Add Products</span>
                                  </Button>
                                </li>
                              </>
                            )}
                        </>
                      )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Card>
            <div className="card-aside-wrap" id="user-detail-block">
              <div className="card-content">
                <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} dataFetched={setDataFetched} />
                {
                  loading ?
                    <>
                      <div className='p-5 d-flex align-center justify-center'>
                        <Spinner />
                      </div>
                    </>
                    :
                    <>{
                      error && error.length > 0 ?
                        <>
                          <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                            <BiErrorCircle className="text-danger fs-3" />
                            <p>{error}</p>
                          </div>
                        </>
                        :
                        <>
                          <div className="card-inner">
                            {
                              activeCardTab === "Main Details" && (
                                <>
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Loading Order Summary</BlockTitle>
                                      <p>A Brief Summary of Loading Order Details.</p>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <ProfileDetailText label="Goods Received Reference Number" text={page_data?.loading_order_ref_no || "---"} />
                                      <ProfileDetailText label="Status" text={page_data?.loading_order_status || "---"} textClassName={page_data?.loading_order_status_id === app_consts.WEIGH_BRIDGE_TICKET_PROCESSING_COMPLETE ? "text-success" : "text-warning"} />
                                      <ProfileDetailText label="Date Created" text={page_data?.inserted_at ? moment(page_data?.inserted_at).format("MMMM Do, YYYY") : "---"} />
                                      <ProfileDetailText label="Total Quantity" text={page_data?.products ? formatScientificNotation(`${calculateTotalQuantity(page_data?.products, "total_mt_capacity")} MT`) : "---"} />
                                      <ProfileDetailText label="Loading Order Type" text={page_data?.loading_order_type ? page_data?.loading_order_type : "---"} />
                                    </div>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Consigner Details</BlockTitle>
                                      <p>Entity that the Loading Order Belongs to</p>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <ProfileDetailText label="User ID" text={page_data?.consigner?.unique_identification_number || "---"} />
                                      <ProfileDetailText label="Name" text={page_data?.consigner?.username || "---"} />
                                      <ProfileDetailText label="Contact person" text={page_data?.contact_person || "---"} />
                                      <ProfileDetailText label="Contact Mobile" text={page_data?.contact_mobile || "---"} />
                                    </div>
                                    <BlockHead className='mt-5'>
                                      <BlockTitle tag="h6">Transport Details</BlockTitle>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <ProfileDetailText label="Transporter Name" text={page_data?.transporter_name || "---"} />
                                      <ProfileDetailText label="Truck Driver Name" text={page_data?.truck_driver_name || "---"} />
                                      <ProfileDetailText label="Truck Reg No" text={page_data?.truck_license_plate || "---"} />
                                      <ProfileDetailText label="Trailer Reg 1 No" text={page_data?.trailer_one || "---"} />
                                      <ProfileDetailText label="Trailer Reg 2 No" text={page_data?.trailer_two || "---"} />
                                    </div>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Loading Instructions</BlockTitle>
                                    </BlockHead>
                                    {/* Table */}
                                    <div className="my-3">
                                      <ReadOnlyTable data={page_data?.driver_instructions} tableType={app_consts.DRIVER_INSTRUCTIONS_TABLE} />
                                    </div>
                                    <BlockHead className='mt-5'>
                                      <BlockTitle tag="h5">Product Details</BlockTitle>
                                      <p>Summary of Products on this Loading Order</p>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <ProfileDetailText label="Total Products" text={page_data?.products?.length > 0 ? `${page_data?.products?.length}` : "---"} />
                                      <ProfileDetailText label="Total Quantity (MT)" text={page_data?.products ? formatScientificNotation(`${calculateTotalQuantity(page_data?.products, "total_mt_capacity")} MT`) : "---"} />
                                    </div>
                                    {products && products.length > 0 && (
                                      <div className="mt-3">
                                        {products.map((product, index) => (
                                          <div key={index} className="card card-bordered mb-2">
                                            <div className="card-inner py-3">
                                              <div className="profile-ud-list">
                                                <ProfileDetailText label="Product Name" text={product?.product_name || product?.product_label || "---"} />
                                                <ProfileDetailText label="Delivery Name" text={product?.delivery_name || product?.delivery_location || "---"} />
                                                <ProfileDetailText label="Branch Location" text={product?.branch_location || product?.branch_location_label || "---"} />
                                                <ProfileDetailText label="Packaging (Bags)" text={product?.packaging_total_number || product?.packaging_number || "---"} />
                                                <ProfileDetailText label="Quantity" text={product?.product_selected_measurement ? formatScientificNotation(product?.product_selected_measurement) : "---"} />
                                                <ProfileDetailText label="Total (MT)" text={product?.total_mt_capacity || product?.quantity_in_mt || "---"} />
                                                <ProfileDetailText label="Amount Left (MT)" text={product?.amount_left || product?.quantity_available || "---"} />
                                                <ProfileDetailText
                                                  label="Status"
                                                  text={product?.product_status || "---"}
                                                  textClassName={
                                                    product?.product_status === app_consts.LOADED
                                                      ? "text-success text-capitalize"
                                                      : product?.product_status === app_consts.NOT_LOADED
                                                        ? "text-warning text-capitalize"
                                                        : ""
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </Block>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Product Information" && (
                                <>
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Main Details</BlockTitle>
                                      <p>Key loading order details shown above the product list.</p>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <ProfileDetailText label="Reference Number" text={page_data?.loading_order_ref_no || "---"} />
                                      <ProfileDetailText label="Status" text={page_data?.loading_order_status || "---"} textClassName={page_data?.loading_order_status_id === app_consts.WEIGH_BRIDGE_TICKET_PROCESSING_COMPLETE ? "text-success" : "text-warning"} />
                                      <ProfileDetailText label="Loading Order Type" text={page_data?.loading_order_type || "---"} />
                                      <ProfileDetailText label="Date Created" text={page_data?.inserted_at ? moment(page_data?.inserted_at).format("MMMM Do, YYYY") : "---"} />
                                      <ProfileDetailText label="Consigner" text={page_data?.consigner?.username || "---"} />
                                      <ProfileDetailText label="Contact Person" text={page_data?.contact_person || "---"} />
                                    </div>
                                    <BlockHead className='mt-5'>
                                      <BlockTitle tag="h5">Loading Order Products</BlockTitle>
                                      <p className='d-flex flex-row' style={{ marginRight: 2 }}>Products: <p className='fw-600' style={{ marginLeft: 2 }}>{page_data?.products?.length}</p> </p>
                                      <p className='d-flex flex-row' style={{ marginRight: 2 }}>Total Capacity: <p className='fw-600' style={{ marginLeft: 2 }}>{`${page_data?.products ? formatScientificNotation(`${calculateTotalQuantity(page_data?.products, "total_mt_capacity")} MT`) : ""}`}</p> </p>
                                    </BlockHead>
                                    {/* Table */}
                                    <div className="my-3">
                                      <ReadOnlyTable data={products} tableType={not_loaded_products_type} />
                                    </div>
                                  </Block>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Loading Order History" && (
                                <>
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Loading Order History</BlockTitle>
                                      <p>Historical Data on Loading Order Amendments</p>
                                    </BlockHead>
                                    {/* Table */}
                                    <div className="my-3">
                                      <ReadOnlyTable data={loading_order_history} tableType={app_consts.GRN_HISTORY} />
                                    </div>
                                  </Block>
                                </>
                              )
                            }

                            {
                              activeCardTab === "Loading Order PDF" && (
                                <>
                                  {
                                    page_data?.loading_order_status?.toLowerCase() !== app_consts.UNDERGOING_PROCESSING?.toLowerCase() ?
                                      <>
                                        <Block>
                                          <BlockHead>
                                            <BlockTitle tag="h5">Loading Order PDF</BlockTitle>
                                            <p>Printable Doucment with Loading Order Details</p>
                                          </BlockHead>
                                          <div className='p-2 border text-gray'>
                                            <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                              <PDFViewer height="100%" width="100%" showToolbar>
                                                <LoadingOrderPDF page_data={page_data} />
                                              </PDFViewer>
                                            </div>
                                          </div>
                                        </Block>
                                      </>
                                      :
                                      <>
                                        <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                                          <BiErrorCircle className="text-danger fs-13" />
                                          <p>Cannot View Loading Order PDF.</p>
                                          <p>Loading Order Processing is Incomplete.</p>
                                        </div>
                                      </>
                                  }
                                </>
                              )
                            }
                            <ModalAdd
                              openModal={add_loading_order_products_modal}
                              setOpenModal={setAddGLoadingOrdersModal}
                              modalTitle="Add Loading Order Products"
                              modalDescription="Please Complete this form to Add Products to Loading Order"
                              type={app_consts.ADD_PRODUCTS_TO_LOADING_ORDER}
                              succFunc={successAddFunction}
                              size="xl"
                              fullscreen
                              page_data={page_data}
                            />

                            <EditLoadingOrderDetailsModal data={page_data} cloasModal={toggleEditLoadingOrderDetailsModal} isOpen={edit_loading_order_details_modal} successFunction={retrive_loading_order_details} />

                            <EditLoadingOrderProductsModal data={page_data} cloasModal={toggleEditLoadingOrderProductssModal} isOpen={edit_loading_order_products_modal} successFunction={retrive_loading_order_details} />
                          </div>
                        </>
                    }
                    </>
                }
              </div>
            </div>
          </Card>
        </Block>
      </Content>
    </>
  );
};

export default LoadingOrderDetails;
